import cx from 'classnames'
import Styles from './CollapsibleField.module.scss'
import { useState } from 'react'
import { Add, Minus } from 'almanac-ui/icons'
import { CollapsibleFieldProps } from './Types'
import { Button } from 'blaze-ui/Button'

export const CollapsibleField = ({ buttonLabel, description, children, isExpanded, error }: CollapsibleFieldProps) => {
  const [expanded, setExpanded] = useState(isExpanded)

  if (expanded) {
    return (
      <>
        <div className={cx(Styles.summary, Styles.expanded)}>
          <Button size="sm" variant="ghost" frontIcon={Minus} onPress={() => setExpanded(false)}>
            {buttonLabel}
          </Button>
        </div>
        <div className={Styles.content}>
          {children}
          {error && <div className={Styles.errorMsg}>{error}</div>}
        </div>
      </>
    )
  }

  return (
    <div className={Styles.summary}>
      <Button size="sm" variant="ghost" frontIcon={Add} onPress={() => setExpanded(true)}>
        {buttonLabel}
      </Button>
      <div className={Styles.description}>{description}</div>
    </div>
  )
}
